import { render, staticRenderFns } from "./AddExistingSentenceModal.vue?vue&type=template&id=3de395ae&lang=pug&"
import script from "./AddExistingSentenceModal.vue?vue&type=script&lang=js&"
export * from "./AddExistingSentenceModal.vue?vue&type=script&lang=js&"
import style0 from "./AddExistingSentenceModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports